import { render, staticRenderFns } from "./DiscussPublish.vue?vue&type=template&id=5f2840ee&scoped=true"
import script from "./DiscussPublish.vue?vue&type=script&lang=js"
export * from "./DiscussPublish.vue?vue&type=script&lang=js"
import style0 from "./DiscussPublish.vue?vue&type=style&index=0&id=5f2840ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2840ee",
  null
  
)

export default component.exports